import React from "react";
import { motion } from "framer-motion";
import { Type, Sparkles, Wallet, Megaphone } from "lucide-react";

const PILLARS = [
  {
    icon: Type,
    title: "Clean English Text",
    body: "Captions, headlines and on-screen labels render correctly — every time. No more garbled glyphs in your ads.",
  },
  {
    icon: Sparkles,
    title: "Pay for What You Keep",
    body: "Only downloaded videos count toward your plan. Generate freely, retry, experiment — never penalized for a bad take.",
  },
  {
    icon: Wallet,
    title: "Weekly or Monthly",
    body: "30 downloads a week or 60 to 350 a month. Flat fee. No credits. Cancel anytime, no hoops.",
  },
  {
    icon: Megaphone,
    title: "Built for Promotion",
    body: "Vertical and square are first-class. Engineered for TikTok, Reels, Shorts and paid social — where business gets done.",
  },
];

export default function Pillars() {
  return (
    <section
      id="pillars"
      data-testid="pillars-section"
      className="relative bg-[#080808] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16 md:mb-20">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.28em] text-[#D4AF37] mb-5">
              Why YBM Studios
            </p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tighter text-[#F4F4F0] leading-[1.02]">
              The AI video tool<br />you actually run your business on.
            </h2>
          </div>
          <p className="md:max-w-sm text-[#A0A0A0] text-base leading-relaxed">
            Most AI video tools are built for entertainment. We're built for promotion —
            ads, brand spots, music drops and product launches that look ready for prime time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/10">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.title}
              data-testid={`pillar-${i}`}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="border-r border-b border-white/10 p-8 md:p-10 group hover:bg-[#0F0F0F] transition-colors"
            >
              <p.icon className="w-7 h-7 text-[#D4AF37] mb-8" strokeWidth={1.5} />
              <h3 className="font-display text-2xl font-bold text-[#F4F4F0] mb-3 tracking-tight">
                {p.title}
              </h3>
              <p className="text-[#A0A0A0] text-sm leading-relaxed">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
